import { sendRequest } from '../axios';

const filter = (getter) => {
  return getter.filter((item) => item.selected).map((item) => item.id);
};
const getFiltred = (filtred, selector, filter) => {
  return filtred.filter((item) => {
    const pri = String(item[selector]).split(",");
    for (const row of filter) {
      const find = pri.find((i) => (Number(i) === Number(row) ? true : false));
      if (find) {
        return true;
      }
    }
  });
};

const saleFilter = (filtred, selector, filter) => {
  return filtred.filter((item) => {
    return item.sale_now.filter((sale) => sale[selector] === filter).length
      ? true
      : false;
  });
};

const saleFilterInLoop = (filtred, LoopArray, fieldName) => {
  return filtred.filter((item) => {
    if (item.sale_now) {
      for (const row of LoopArray) {
        for (const sale of item.sale_now) {
          if (sale[fieldName] === row) {
            return true;
          }
        }
      }
    }
  });
};

export default {
  state: {
    filterLoading: false,
    showFilterBox: false,
    filterBoxPosition: {
      top: 0,
      left: 0,
    },
    count: 0,
    countLoading: false,
    showFunc: () => {},

    limits: [],
    principals: [],
    lifes: [],
    garantZakaz: false,
    practices: [],
    packets: [],
    usns: [],
    edos: [],
    up_box: false,
    what_fee: null,
    agentsFeeMinType: [],
    // agentsFeeMin: "",
    // agentsFeeMinType: 1,
    // agentsFeeMax: "",
    // agentsFeeMaxType: 1,
    nettoFeeType: [],
    // nettoFee: "",
    // nettoFeeType: 1,
    // nettoFeeMax: "",
    // nettoFeeMaxType: 1,
    agentsupMin: "",
    agentsupMinType: [],
    // agentsupMinType: 1,
    agentsupMax: "",
    // agentsupMaxType: 1,
    down_bank: false,
    down_agent: false,
    down_bank_agent: false,
    minFee: "",
    min_tarif: false,
    // minFeeType: 1,
    minFeeType: [],
    edo_sdelka: false,
    edo_mounth: false,
    edo_decada: false,
    edo_week: false,
    edo_personal: false,
  },
  mutations: {
    SET_FILTER_LOADING(state, payload) {
      state.filterLoading = payload;
    },
    SET_SHOW_FUNC(state, payload) {
      state.showFunc = payload;
    },
    SET_FILTER_COUNT(state, payload) {
      state.count = payload;
    },
    SET_FILTER_COUNT_LOADING(state, payload) {
      state.countLoading = payload;
    },
    SET_SHOW_FILTER_BOX(state, payload) {
      state.showFilterBox = payload;
    },
    SET_FILTER_POSITION(state, payload) {
      state.filterBoxPosition = payload;
    },
    set_limits(state, payload) {
      state.limits = payload;
    },
    set_principals(state, payload) {
      state.principals = payload;
    },
    set_lifes(state, payload) {
      state.lifes = payload;
    },
    set_garantZakaz(state, payload) {
      state.garantZakaz = payload;
    },
    set_practices(state, payload) {
      state.practices = payload;
    },
    set_packets(state, payload) {
      state.packets = payload;
    },
    set_usns(state, payload) {
      state.usns = payload;
    },
    set_edos(state, payload) {
      state.edos = payload;
    },
    set_up_box(state, payload) {
      state.up_box = payload;
    },
    set_what_fee(state, payload) {
      state.what_fee = payload;
    },
    set_agentsFeeMin(state, payload) {
      state.agentsFeeMin = payload;
    },
    set_agentsFeeMinType(state, payload) {
      state.agentsFeeMinType = payload;
    },
    set_agentsFeeMax(state, payload) {
      state.agentsFeeMax = payload;
    },
    set_agentsFeeMaxType(state, payload) {
      state.agentsFeeMaxType = payload;
    },
    set_nettoFee(state, payload) {
      state.nettoFee = payload;
    },
    set_nettoFeeType(state, payload) {
      state.nettoFeeType = payload;
    },
    set_nettoFeeMax(state, payload) {
      state.nettoFeeMax = payload;
    },
    set_nettoFeeMaxType(state, payload) {
      state.nettoFeeMaxType = payload;
    },
    set_agentsupMin(state, payload) {
      state.agentsupMin = payload;
    },
    set_agentsupMinType(state, payload) {
      state.agentsupMinType = payload;
    },
    set_agentsupMax(state, payload) {
      state.agentsupMax = payload;
    },
    set_agentsupMaxType(state, payload) {
      state.agentsupMaxType = payload;
    },
    set_down_bank(state, payload) {
      state.down_bank = payload;
    },
    set_down_agent(state, payload) {
      state.down_agent = payload;
    },
    set_down_bank_agent(state, payload) {
      state.down_bank_agent = payload;
    },
    set_minFee(state, payload) {
      state.minFee = payload;
    },
    set_min_tarif(state, payload) {
      state.min_tarif = payload;
    },
    set_minFeeType(state, payload) {
      state.minFeeType = payload;
    },
    set_edo_sdelka(state, payload) {
      state.edo_sdelka = payload;
    },
    set_edo_mounth(state, payload) {
      state.edo_mounth = payload;
    },
    set_edo_decada(state, payload) {
      state.edo_decada = payload;
    },
    set_edo_week(state, payload) {
      state.edo_week = payload;
    },
    set_edo_personal(state, payload) {
      state.edo_personal = payload;
    },
  },
  actions: {
    getRate({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`rate/${data}`, "get", undefined, reject).then(
          (response) => {
            resolve(response);
          }
        ).finally(()=>{
          commit("SET_PROCESSING", false);
        });
      });
    },
    async FILTERDED({ getters }, data) {
      //фильтрация принципала

      //создание копии
      let filtred = data.map((item) => item);
      let duplicateFiltred = data.map((item) => item);

      const principals = filter(getters.get_principals);
      if (principals.length) {
        filtred = getFiltred(filtred, "principal", principals);
      }
      // фильтрация лимитов
      const limits = filter(getters.get_limits);
      if (limits.length) {
        filtred = filtred.filter((item) => {
          for (const l of limits) {
            if (item.limit === l) {
              return true;
            }
          }
        });
      }

      //Гарантия по форме заказчика garantZakaz
      const garantZakaz = getters.get_garantZakaz;
      if (garantZakaz) {
        filtred = filtred.filter((item) => {
          if (garantZakaz === true && item.garantZakaz === 1) {
            return true;
          }
        });
      }

      //Срок существования клиента
      const lifes = filter(getters.get_lifes);
      if (lifes.length) {
        filtred = getFiltred(filtred, "lifes", lifes);
      }

      //Опыт исполнения контрактов и/или договоров
      const practices = filter(getters.get_practices);

      if (practices.length) {
        filtred = getFiltred(filtred, "practices", practices);
      }

      //Пакет документов для получения гарантии
      const packets = filter(getters.get_packets);

      if (packets.length) {
        filtred = getFiltred(filtred, "packets", packets);
      }

      //Промежуточная управленческая отчетность ф.1 и ф.2 при УСН
      const usns = filter(getters.get_usns);

      if (usns.length) {
        filtred = getFiltred(filtred, "usn", usns);
      }

      //ЭДО с агентом
      const edos = filter(getters.get_edos);

      if (edos.length) {
        filtred = getFiltred(filtred, "edos", edos);
      }

      //Условия работы с агентами
      // тип работы
      const what_fee = getters.get_what_fee;
      if (what_fee !== null) {
        filtred = saleFilter(filtred, "what_fee", what_fee);
        if (what_fee === "range") {
          const agentsFeeMinType = getters.get_agentsFeeMinType
            .filter((item) => item.selected)
            .map((item) => Number(item.name));
          if (agentsFeeMinType.length) {
            filtred = filtred.filter((item) => {
              if (item.sale_now) {
                for (const row of agentsFeeMinType) {
                  for (const sale of item.sale_now) {
                    if (sale.agentsFeeMax <= row) {
                      return true;
                    }
                  }
                }
              }
            });
          }
          // filtred
        }
        // if(what_fee === 'netto'){
        //   const nettoFeeType = filter(getters.get_nettoFeeType)
        //   if(nettoFeeType.length){
        //     filtred = saleFilterInLoop(filtred,nettoFeeType,'nettoFeeType')
        //   }
        // }
      }

      //Возможность согласовать повышенное АВ
      const up_box = getters.get_up_box;
      if (up_box) {
        filtred = saleFilter(filtred, "up_box", up_box === true ? 1 : 0);
      }

      //Условия выплат агентам при превышении стандартного тарифа
      const agentsupMinType = getters.get_agentsupMinType
        .filter((item) => item.selected)
        .map((item) => Number(item.name));
      let ab100 = false;
      if (agentsupMinType.length) {
        filtred = filtred.filter((item) => {
          if (item.sale_now) {
            for (const row of agentsupMinType) {
              for (const sale of item.sale_now) {
                if (sale.agentsupMin >= row) {
                  if (row === 100) {
                    ab100 = true;
                  }
                  return true;
                }
              }
            }
          }
        });
      }

      if (ab100) {
        filtred = Array.from(
          new Set([
            ...filtred,
            ...saleFilter(duplicateFiltred, "what_fee", "netto"),
          ])
        );
      }

      //Условия выплат агентам при снижении
      //за счет Банка
      const down_bank = getters.get_down_bank;
      if (down_bank) {
        filtred = saleFilter(filtred, "down_bank", down_bank === true ? 1 : 0);
      }

      //за счет Агента
      const down_agent = getters.get_down_agent;
      if (down_agent) {
        filtred = saleFilter(
          filtred,
          "down_agent",
          down_agent === true ? 1 : 0
        );
      }

      //За счет Банка и Агента
      const down_bank_agent = getters.get_down_bank_agent;
      if (down_bank_agent) {
        filtred = saleFilter(
          filtred,
          "down_bank_agent",
          down_bank_agent === true ? 1 : 0
        );
      }

      //Минимальный тариф
      const min_tarif = getters.get_min_tarif;
      if (min_tarif) {
        filtred = saleFilter(filtred, "min_tarif", min_tarif === true ? 1 : 0);
        const minFeeType = filter(getters.get_minFeeType);
        if (minFeeType.length) {
          filtred = saleFilterInLoop(filtred, minFeeType, "minFeeType");
        }
      }

      //Выплаты АВ
      // по сделке
      const edo_sdelka = getters.get_edo_sdelka;
      if (edo_sdelka) {
        filtred = saleFilter(
          filtred,
          "edo_sdelka",
          edo_sdelka === true ? 1 : 0
        );
      }
      // ежемесячно
      const edo_mounth = getters.get_edo_mounth;
      if (edo_mounth) {
        filtred = saleFilter(
          filtred,
          "edo_mounth",
          edo_mounth === true ? 1 : 0
        );
      }
      // по декадам
      const edo_decada = getters.get_edo_decada;
      if (edo_decada) {
        filtred = saleFilter(
          filtred,
          "edo_decada",
          edo_decada === true ? 1 : 0
        );
      }
      // еженедельно
      const edo_week = getters.get_edo_week;
      if (edo_week) {
        filtred = saleFilter(filtred, "edo_week", edo_week === true ? 1 : 0);
      }
      // индивидуально
      const edo_personal = getters.get_edo_personal;
      if (edo_personal) {
        filtred = saleFilter(
          filtred,
          "edo_personal",
          edo_personal === true ? 1 : 0
        );
      }

      return filtred;
    },
    async CALC_FILTER({ commit, getters, dispatch }) {
      commit("SET_FILTER_COUNT_LOADING", true);
      try {
        const data = getters.getPodhodit.map((item) => item);
        const filtred = await dispatch("FILTERDED", data);
        commit("SET_FILTER_COUNT", filtred.length);
        return filtred;
      } finally {
        commit("SET_FILTER_COUNT_LOADING", false);
      }
    },
  },
  getters: {
    getFilterLoading: (state) => state.filterLoading,

    getShowFilterBox: (state) => state.showFilterBox,
    getFilterBoxPosition: (state) => state.filterBoxPosition,
    getFilterCount: (state) => state.count,
    getFilterCountLoading: (state) => state.countLoading,
    getFilterShowFunc: (state) => state.showFunc,

    get_limits: (state) => state.limits,
    get_principals: (state) => state.principals,
    get_lifes: (state) => state.lifes,
    get_garantZakaz: (state) => state.garantZakaz,
    get_practices: (state) => state.practices,
    get_packets: (state) => state.packets,
    get_usns: (state) => state.usns,
    get_edos: (state) => state.edos,
    get_up_box: (state) => state.up_box,
    get_what_fee: (state) => state.what_fee,
    get_agentsFeeMin: (state) => state.agentsFeeMin,
    get_agentsFeeMinType: (state) => state.agentsFeeMinType,
    get_agentsFeeMax: (state) => state.agentsFeeMax,
    get_agentsFeeMaxType: (state) => state.agentsFeeMaxType,
    get_nettoFee: (state) => state.nettoFee,
    get_nettoFeeType: (state) => state.nettoFeeType,
    get_nettoFeeMax: (state) => state.nettoFeeMax,
    get_nettoFeeMaxType: (state) => state.nettoFeeMaxType,
    get_agentsupMin: (state) => state.agentsupMin,
    get_agentsupMinType: (state) => state.agentsupMinType,
    get_agentsupMax: (state) => state.agentsupMax,
    get_agentsupMaxType: (state) => state.agentsupMaxType,
    get_down_bank: (state) => state.down_bank,
    get_down_agent: (state) => state.down_agent,
    get_down_bank_agent: (state) => state.down_bank_agent,
    get_minFee: (state) => state.minFee,
    get_min_tarif: (state) => state.min_tarif,
    get_minFeeType: (state) => state.minFeeType,
    get_edo_sdelka: (state) => state.edo_sdelka,
    get_edo_mounth: (state) => state.edo_mounth,
    get_edo_decada: (state) => state.edo_decada,
    get_edo_week: (state) => state.edo_week,
    get_edo_personal: (state) => state.edo_personal,
  },
};
